// extracted by mini-css-extract-plugin
module.exports = {"ProfileImage":"ProfileImage_ProfileImage__2LllA","AddIcon":"ProfileImage_AddIcon__7FKXl","UploadedImage":"ProfileImage_UploadedImage__36LVH"};